import * as React from 'react';

interface Props {
  login: () => void;
  register: () => void;
}

class GuestUserNavToolsComponent extends React.Component<Props> {
  render() {

    return [
      (
        <li key="login">
          <a
            className="btn btn-primary margin-r-10"
            onClick={() => this.props.login()}
          >
            Iniciar sesión
          </a>
        </li>
      ),
      (
        <li key="signup">
          <a
            className="btn btn-secondary"
            onClick={() => this.props.register()}
          >
            Regístrate
          </a>
        </li>
      )
    ];
  }
}

export default GuestUserNavToolsComponent;



// WEBPACK FOOTER //
// ./src/modules/commons/header/partials/GuestUserNavTools.component.tsx